
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";
import { Post } from "@/components/post/Post";
import { useAuth } from "@/contexts/AuthContext";
import { useProfile } from "@/hooks/useProfile";

export const PostsList = () => {
  const { user } = useAuth();
  const { profile, isLoading: isProfileLoading } = useProfile();

  const { data: posts, isLoading, error } = useQuery({
    queryKey: ["feed-posts", user?.id, profile?.is_pro],
    queryFn: async () => {
      console.log('Fetching posts with profile:', profile);
      
      let query = supabase
        .from("posts")
        .select(`
          *,
          profiles (
            username,
            full_name,
            avatar_url,
            is_pro
          ),
          comments (
            id,
            content,
            created_at,
            user_id,
            profiles (
              username,
              avatar_url
            )
          )
        `)
        .order('created_at', { ascending: false });

      // If user is not pro, exclude private posts from other users
      if (!profile?.is_pro) {
        query = query.or(`is_private.eq.false,user_id.eq.${user?.id}`);
      }

      const { data, error } = await query;

      if (error) {
        console.error('Error fetching posts:', error);
        throw error;
      }

      console.log('Fetched posts:', data);
      return data;
    },
    enabled: !!user && !isProfileLoading,
    staleTime: 5000,
    gcTime: Infinity,
  });

  if (error) {
    return (
      <div className="p-4 text-center text-red-400">
        Error loading posts. Please try again later.
      </div>
    );
  }

  if (isLoading || isProfileLoading) {
    return (
      <div className="space-y-4 p-4">
        {[...Array(3)].map((_, i) => (
          <div key={i} className="animate-pulse">
            <div className="h-12 bg-gray-700/20 rounded-t" />
            <div className="h-24 bg-gray-700/10" />
            <div className="h-10 bg-gray-700/20 rounded-b" />
          </div>
        ))}
      </div>
    );
  }

  if (!posts?.length) {
    return (
      <div className="p-4 text-center text-gray-400">
        No posts yet. Be the first to post!
      </div>
    );
  }

  return (
    <div className="divide-y divide-flux-cyan/10">
      {posts.map((post) => (
        <Post
          key={post.id}
          post={post}
          currentUserId={user?.id}
        />
      ))}
    </div>
  );
};
